<div class="update-status-container" style="background: #161616;border-radius: 3px;">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="title fc_DEDEDE">Status change</div>
    <mat-icon fontSet="material-icons-round" (click)="cancel()" class="fc_DEDEDE cursor_pointer">close</mat-icon>
  </div>

  <div class="description">You are changing the status of lot</div>
  <div fxLayout="row wrap" fxLayoutGap="8px">
    <div class="property-name" *ngFor="let lot of lots">{{lot.lotNumber}}</div>
  </div>
  <div class="description">to status</div>
  <div style="">
    <ng-container *ngIf="targetStatus === 0">
      <span class="status-point" style="background: #B0DDCD"></span><span style="color: #B0DDCD;">Unavailable</span>
    </ng-container>
    <ng-container *ngIf="targetStatus === 1">
      <span class="status-point" style="background: #03BC79"></span><span style="color: #B0DDCD;">Available</span>
    </ng-container>
    <ng-container *ngIf="targetStatus === 2 || targetStatus === 3">
      <span class="status-point" style="background: #FFC01D"></span><span style="color: #B0DDCD;">Reserved</span>
    </ng-container>
    <ng-container *ngIf="targetStatus === 4 || targetStatus === 5">
      <span class="status-point" style="background: #2589FE"></span><span style="color: #B0DDCD;">Processing</span>
    </ng-container>
    <ng-container *ngIf="targetStatus === 6">
      <span class="status-point" style="background: #B0B0B0"></span><span style="color: #B0DDCD;">Settle</span>
    </ng-container>
  </div>
  <div fxLayout="row" fxLayoutAlign="center" class="mt_20">
    <button mat-flat-button class="cancel-button" (click)="cancel()">Back</button>
    <button mat-flat-button class="confirm-button" (click)="confirm()">Update</button>
  </div>
</div>